import { FC } from "react";
import { useScript } from "../../../app/hooks";
import { BUTTON_CLASSNAME } from "../formElements";
import { reCaptchaKey } from "../../../reCaptcha";

import "./styles.css";
import { StringStateAction } from "../../../helpers/functions/types";
import { reCaptchaUrl } from "./constants";

type ReCaptchaProps = {
  errorMessage: string;
  actionName: "signup" | "password_reset" | "invite_accept";
  setRecaptchaToken?: StringStateAction;
  showNextButton?: boolean;
  setErrorMessage: StringStateAction;
};

const RECAPTCHA_ACTION_MESSAGE =
  "please refresh the page or try a different browser.";

const RECAPTCHA_FAIL_MESSAGE = `Could not obtain recaptcha, ${RECAPTCHA_ACTION_MESSAGE}`;

const INIT_VERIFY_MESSAGE = "Please verify with recaptcha";
const FOLLOW_UP_VERIFY_MESSAGE = `${INIT_VERIFY_MESSAGE}. If you don't see recaptcha ${RECAPTCHA_ACTION_MESSAGE}`;

export const getRecaptchaValue =
  (setErrorMessage: StringStateAction, setRecaptchaToken?: StringStateAction) =>
  (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    try {
      const { value } = document.getElementsByName(
        "g-recaptcha-response",
      )[0] as HTMLInputElement;

      if (value) {
        if (setRecaptchaToken) {
          setRecaptchaToken(value);
        } else {
          return value;
        }
      } else {
        setErrorMessage((previousMessage) =>
          previousMessage.startsWith(INIT_VERIFY_MESSAGE)
            ? FOLLOW_UP_VERIFY_MESSAGE
            : INIT_VERIFY_MESSAGE,
        );
      }
    } catch (e) {
      setErrorMessage(RECAPTCHA_FAIL_MESSAGE);
    }
  };

export const ReCaptcha: FC<ReCaptchaProps> = ({
  errorMessage,
  setErrorMessage,
  setRecaptchaToken,
  actionName,
  showNextButton = true,
}) => {
  useScript(reCaptchaUrl, "", false, () =>
    setErrorMessage(RECAPTCHA_FAIL_MESSAGE),
  );

  return (
    <>
      <div
        id="g-recaptcha"
        className="g-recaptcha"
        data-sitekey={reCaptchaKey}
        data-action={actionName}
      ></div>

      {showNextButton && errorMessage !== RECAPTCHA_FAIL_MESSAGE && (
        <button
          type="button"
          onClick={getRecaptchaValue(setErrorMessage, setRecaptchaToken)}
          className={`${BUTTON_CLASSNAME} mt-4`}
        >
          Next
        </button>
      )}
    </>
  );
};
